/* eslint import/no-webpack-loader-syntax: off */
import css from "!!raw-loader!./box.css";
const box = {
  id: "box3",
  css,
};
export default box;
